@import (reference) '../../../../constants/spacing.module.less';

.breadcrumb {
  padding: @space-12 @space-16;
  background-color: var(--gray-F9FAFB);
  border-bottom: 1px solid var(--grey-400);
  align-items: center;
  gap: @space-8;
  align-self: stretch;
}

.link {
  color: var(--blue-006FBB);
  text-decoration: none;
}

.breadcrumb-font {
  font-size: 16px;
}
